import { useEffect, useState } from 'react'
import getPermission from '@fs/zion-permissions'

export const validStates = {
  AUTHORIZED: 'AUTHORIZED',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  UNAUTHORIZED: 'UNAUTHORIZED',
}

export default function usePermissions(calculatePermissions) {
  const [error, setError] = useState()
  const [state, setState] = useState(validStates.LOADING)

  useEffect(() => {
    let canceled = false

    calculatePermissions({ all, any })
      .then((result) => {
        if (canceled) return
        setState(result ? validStates.AUTHORIZED : validStates.UNAUTHORIZED)
      })
      .catch((err) => {
        if (canceled) return
        console.error(err)
        setError(err)
        setState(validStates.ERROR)
      })

    return () => {
      canceled = true
    }
  }, [calculatePermissions])

  return { authorized: state === validStates.AUTHORIZED, error, loading: state === validStates.LOADING, state }
}

function all(...permissionDefinitions) {
  return Promise.all(permissionDefinitions.map((permission) => resolvePermission(permission))).then((results) =>
    results.every((result) => result === true)
  )
}

function any(...permissionDefinitions) {
  return Promise.all(permissionDefinitions.map((permission) => resolvePermission(permission))).then((results) =>
    results.some((result) => result === true)
  )
}

function requestPermissions({ context, permissions }) {
  return getPermission(permissions, context).then((response) => response.authorized)
}

function resolvePermission(value) {
  if (value instanceof Promise) return value
  return requestPermissions(value)
}
